$(function() {
    var cboxOptions = {
        maxWidthLg: '400px',
        maxHeightLg: '400px',
        maxWidthMd: '400px',
        maxHeightMd: '400px',
        maxWidthSm: '320px',
        maxHeightSm: 'auto'
      };
      let confirmedOrderFlag = true;
      function checkWidth() {
          if (window.innerWidth < 376) {
            return cboxOptions.maxWidthSm;
          }  else {
            return cboxOptions.maxWidthMd;
          }
        };
    function skipOrderModalpopUp(){
		   skipOrderAPICall();
           ACC.colorbox.open('', {
             escKey: false,
             overlayClose: false,
             closeButton: false,
             html: $('#skipOrderModal').html(),
             onLoad: $('#cboxOverlay').css('position', 'fixed'),
             width: checkWidth(),
             height: cboxOptions.maxHeightMd,
             className: 'skipOrderModal'
          });

    }
    function skipOrderAPICall(){
		$.ajax({
            type: 'GET',
            url: '/my-account-home/reorder-reminder/resolve/continuecare',
            dataType: 'json',
            contentType : 'application/json',
            success: function(data) {
			},
			error:function(err){
			}
		});
	}
		function confirmedOrder(){
        if(!confirmedOrderFlag) return false;
        confirmedOrderFlag = false;
    		$.ajax({
                type: 'GET',
                url: '/checkout/multi/reorderSummary/placeReorder',
                dataType: 'json',
                contentType : 'application/json',
                success: function(data) {
                    //update est shipping date:
                   var expectedShipDate = data.split('?')[1];
                   if(expectedShipDate.indexOf('expectedShipDate')== 0){
                       $('.confirmedOrderModal').find('.shipping-date').html(expectedShipDate.split('=')[1]);
                       showConfirmedOrderModal();
                   }
                    
                },
    			error:function(err){
          confirmedOrderFlag = true;
					console.log("API error");
    			}
    		});

    	}

    	function showConfirmedOrderModal(){
    		ACC.colorbox.open('', {
             escKey: false,
             overlayClose: false,
             closeButton: false,
             html: $('#confirmedOrderModal').html(),
             onLoad: $('#cboxOverlay').css('position', 'fixed'),
             width: checkWidth(),
             height: cboxOptions.maxHeightMd,
             className: 'confirmedOrderModal'
           });
    	}
    function accountPageRedirect(){
        window.location.href = '/my-account-home/page';
    }
    function init() {
        $(document).on('click', '.oneClick-reorder-confirm-btn', confirmedOrder);
        $(document).on('click', '.oneClick-reorder-skip-btn', skipOrderModalpopUp);
        $(document).on('click','.continue-to-account-btn',accountPageRedirect)
        $(window).resize(function() {
                     $.colorbox.resize({
                       width:checkWidth(),
                       height:cboxOptions.maxHeightMd
                     });

        	      });
      }
       init();
});
